<template>
    <!-- <div> -->
        <!-- <div class="condition">
            <div style="display: inline-block;margin-right:10px;">布局</div>
            <el-checkbox v-model="dragable"></el-checkbox>

            <el-button size="mini" type="primary" @click="save" style="margin-left: 30px;">保存布局</el-button>
        </div> -->
    <div class="list" ref="list">
        <vue-drag-resize class="dragebox"
            v-for="(item, index) in list"
            :key="index"
            :w="item.width"
            :h="100"
            :x="item.left"
            :y="item.top"
            :parentLimitation="false"
            :isActive="item.isActive"
            :isDraggable="dragable"
            @dragstop="dragstop($event, index)"
            @resizestop="resizestop($event, index)"
            @activated="activateEv(index)"
            @deactivated="deactivatedEv(index)"
        >
            <!-- <div class="item">
                {{item.moduleAlias}}
            </div> -->
            <div class="item">
                <el-col :span="11">{{item.moduleAlias}}</el-col>
                <el-col :span="12" :offset="1">{{item.moduleVersion}}</el-col>                
            </div>
            <div class="item" v-for="(device, idx) in item.deviceInstalleds.slice(0, 2)" :key="idx">
                <span>{{device.name}}({{device.createNum}})</span>
            </div>
            <div v-if="item.deviceInstalleds.length > 2" class="more"> 
                <el-tooltip placement="left" effect="light">
                    <div slot="content">
                        <div v-for="(de, didx) in item.deviceInstalleds" 
                            :key="didx"
                            style="padding: 6px;">
                            {{de.name}}({{de.createNum}})
                        </div>
                    </div>
                    <span>...</span>
                </el-tooltip>
            </div>
        </vue-drag-resize>
        <div class="deleteIcon" title="将模块框移到此处，将删除" id="layoutDel">
            <i class="el-icon-delete-solid"></i>
        </div>
        <!-- <device-list 
            v-if="showDevice" 
            :visible="showDevice" 
            :selectedRows="selectedRows"
            @deviceCallback="deviceCallback"/> -->
    </div>
    <!-- </div> -->
</template>
<script>
import VueDragResize from "vue-drag-resize";
// import DeviceList from './DragDeviceList'
export default {
  components: {
    VueDragResize
  },

  props: {
    //  是否可拖拽
    dragable: {
        type: Boolean,
        default: false
    },
    dragList:{
        type: Array,
        default: 30
    },

  },

  data() {
    return {
    //   list: [],
    //   showDevice: false,
      activeIndex: null, //当前选中的元素
      selectedRows: []
    };
  },
  computed: {
      list(){
          return this.dragList ? this.dragList : []
      }
  },
//   watch: {
//       dragList:{
//           handler(newVal, oldVal){
//               this.list = newVal
//           },
//           deep: true
//       }
//   },

  methods: {
    // 当前活动的div
    activateEv(index){
        this.list.forEach(obj => {
            obj.isActive = false
        })
        this.list[index].isActive = true
        this.activeIndex = index
        this.selectedRows = this.list[index].deviceInstalleds
        
        if(!this.dragable){
            // this.showDevice = true
            this.$emit('deviceShowCallback', this.activeIndex )
        }
        
    },
    // 点击空白处，取消选中状态
    deactivatedEv(index){
      this.list[index].isActive = false
    },
    // 拖拽结束后修改位置
    dragstop(item, index){
        this.list[index].top = item.top
        this.list[index].left = item.left
        let listWidth = this.$refs.list.clientWidth
        let itemRight = item.width + item.left
        
        // 将元素移到右上角，将删除元素
        if(item.top <10 && Math.abs(listWidth - itemRight) < 10){
            this.$emit('delDragItem', this.list[index].moduleVersionId)
            this.list.splice(index, 1)
        }
    },
    resizestop(item, index){
        this.list[index].width = item.width
        this.list[index].width = item.width        
        this.list[index].top = item.top
        this.list[index].left = item.left
        console.log(item)
    },
    // 选择设备回调
    // deviceCallback(val){
    //     this.showDevice = false
    //     if(val != false){
    //         this.list[this.activeIndex].deviceInstalleds = val
    //     }
    // },
  }
};
</script>
<style scoped>
.condition{
    position: absolute;
    top: 0;
    right: 0;
    line-height: 40px;
}

.list{
     position: absolute;
        /* top: 280px;
        bottom: 30px;
        left: 28px;
        right: 300px; */
        /* box-shadow: 0 0 2px #AAA;
        background-color: white; */
        border: 1px solid #ccc;

        top: 0px;
        right: 0;
        width: 70%;
        height: 500px;
        margin-bottom: 20px;
}
.dragebox{
    background-color: #c6eab4;
    text-align: center;
    border: 1px solid #f1ecec;
}
.deleteIcon{
    position: absolute;
    right: 0;
    top: 0;
    padding: 6px;
}
.deleteIcon i{
    font-size: 24px;
}
.item, .item div{
    /* text-align: center; */
    margin-bottom: 4px;    
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
/* .title{
    text-align: left;
} */
.title div{
    display: inline-block;
}
.more{
    cursor: pointer;
}
.saveBtn{
    position: absolute;
    bottom: 10px;
    right: 10px;
}
</style>